// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MainLayout as Orders__MainLayout } from "../Orders/MainLayout.js";
import { MatCardModule } from "@angular/material/card";
import { CustomerRequestViewInclude as Orders__CustomerRequestViewInclude } from "../Orders/CustomerRequestViewInclude.js";
import { MatButtonModule } from "@angular/material/button";

interface Properties {
    request: This.CustomerRequest;
    mail: Sys.Types.Mail;
    mailTimestamp: number;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-CustomerOrderProcess',
    templateUrl: './CustomerOrderProcess.html',
    styleUrls: ['./CustomerOrderProcess.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        Orders__MainLayout,
        MatCardModule,
        Orders__CustomerRequestViewInclude,
        MatButtonModule
    ],
})
export class CustomerOrderProcess extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.CustomerOrderProcess';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    @Output()
    submit = new EventEmitter<null>();
    output = {
        submit: async (data: null, followNextUserTask = true) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any
            result = await (followNextUserTask ? Sys.Process.driveProcessAndFollowNextUserTask : Sys.Process.driveProcess)('submit', data)
            this.submit.emit(data)
            if (this.dialogData?.closeOnOutput === 'submit') { this.dialogRef?.close(data) }
            return result
        },
    };
    $validators: Record<number, ValidationRules> = {

    };
    input_request = input(undefined, { alias: 'request' });
    var_request = proxySignal<This.CustomerRequest>(undefined as any);
    input_mail = input(undefined, { alias: 'mail' });
    var_mail = proxySignal<Sys.Types.Mail>(undefined as any);
    input_mailTimestamp = input(undefined, { alias: 'mailTimestamp' });
    var_mailTimestamp = proxySignal<number>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get request() { return component.var_request() },
                set request(value: This.CustomerRequest) { component.var_request.set(value) },
                get mail() { return component.var_mail() },
                set mail(value: Sys.Types.Mail) { component.var_mail.set(value) },
                get mailTimestamp() { return component.var_mailTimestamp() },
                set mailTimestamp(value: number) { component.var_mailTimestamp.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            request: this.screen.request,
            mail: this.screen.mail,
            mailTimestamp: this.screen.mailTimestamp
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_request = this.dialogData?.data?.request ?? this.input_request() ?? (undefined)
            if (new_request !== undefined) this.screen.request = new_request


            const new_mail = this.dialogData?.data?.mail ?? this.input_mail() ?? (undefined)
            if (new_mail !== undefined) this.screen.mail = new_mail


            const new_mailTimestamp = this.dialogData?.data?.mailTimestamp ?? this.input_mailTimestamp() ?? (undefined)
            if (new_mailTimestamp !== undefined) this.screen.mailTimestamp = new_mailTimestamp

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_ButtonBlock_25_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    output.submit(null)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
